import { cn } from '../../lib/utils'

export interface SectionProps {
  label: string
  action?: React.ReactNode
  className?: string
  children?: React.ReactNode
}

export function Section({ label, action, className, children }: SectionProps) {
  return (
    <section className={cn('mb-7', className)}>
      <div className="mb-3 flex items-baseline gap-3">
        <h3 className="text-ink-3 m-0 text-xs font-semibold uppercase tracking-[0.08em]">
          {label}
        </h3>
        {action && <div className="ml-auto text-xs text-ink-3">{action}</div>}
      </div>
      {children}
    </section>
  )
}
